import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Louve from '../icons/LouveOld';

import styles from '../../../styles/partials/fnc-logo.module.scss';

const propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool,
    isStacked: PropTypes.bool,
    isInOpenMenu: PropTypes.bool,
};

const defaultProps = {
    className: null,
    loading: false,
    isStacked: false,
    isInOpenMenu: false,
};

const FncLogo = ({ className, loading, isStacked, isInOpenMenu }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.isLoading]: loading,
                [styles.isStacked]: isStacked,
                [styles.isInOpenMenu]: isInOpenMenu,
            },
        ])}
    >
        <Louve className={classNames(styles.part, styles.louve)} loading={loading} />

        <div className={styles.acronym}>
            <svg
                className={styles.part}
                xmlns="http://www.w3.org/2000/svg"
                width="43.96"
                height="30.81"
                viewBox="0 0 43.96 30.81"
            >
                <path d="M5.64,6v8.08h5.07v5.63H5.64V30.43H0V.38H10.71V6Z" />
                <path d="M28.33.38V30.43H22.69L17.85,15.59V30.43H12.21V.38h5.64l4.84,14.84V.38Z" />
                <path d="M38.33,8.94c0-2.55-.19-3.3-1.43-3.3s-1.43.75-1.43,3.3V21.87c0,2.55.19,3.3,1.43,3.3s1.43-.75,1.43-3.3V18.22H44v4c0,6.05-2.52,8.57-7.06,8.57s-7.06-2.52-7.06-8.57V8.57C29.84,2.52,32.35,0,36.9,0S44,2.52,44,8.57v4H38.33Z" />
            </svg>
        </div>

        <div className={styles.edition}>
            <svg
                className={styles.part}
                xmlns="http://www.w3.org/2000/svg"
                width="19.52"
                height="25.16"
                viewBox="0 0 19.52 25.16"
            >
                <path d="M19.52,4.68v-1.43c0-2.12-.55-3.1-2.08-3.1s-2.12,.98-2.12,3.1v2.62c0,2.12,.59,3.11,2.12,3.11s2.08-.99,2.08-3.11v-.38h-.95v.68c0,1.58-.42,1.95-1.13,1.95s-1.17-.37-1.17-1.95v-1.5h3.25Zm-3.25-1.72c0-1.6,.47-1.95,1.17-1.95s1.13,.36,1.13,1.95v.99h-2.3v-.99Z" />
                <path d="M1.49,20.24c-.86,0-1.18,.54-1.18,1.73v1.46c0,1.18,.33,1.73,1.18,1.73s1.16-.55,1.16-1.73v-.21h-.53v.38c0,.88-.23,1.09-.63,1.09s-.65-.21-.65-1.09v-.84h1.81v-.8c0-1.18-.31-1.73-1.16-1.73Zm.63,2.12H.83v-.55c0-.89,.26-1.09,.65-1.09s.63,.2,.63,1.09v.55Z" />
                <polygon points=".53 19.84 2.51 19.29 2.44 19 .46 19.55 .53 19.84" />
                <path d="M5.46,19.21h-.53v1.64c-.11-.27-.36-.61-.88-.61-.65,0-.93,.43-.93,1.47v1.97c0,1.04,.28,1.48,.93,1.48,.52,0,.77-.35,.88-.61,0,.13,.04,.43,.11,.54h.5c-.07-.24-.07-.4-.07-.7v-5.17Zm-.53,4.55c0,.46-.2,.93-.69,.93-.45,0-.59-.35-.59-.87v-2.23c0-.52,.14-.87,.59-.87,.5,0,.69,.46,.69,.92v2.12Z" />
                <rect x="6.05" y="20.32" width=".53" height="4.77" />
                <path d="M6.41,19.09c-.17,0-.32,.14-.32,.32s.15,.31,.32,.31c.18,0,.32-.14,.32-.31s-.14-.32-.32-.32Z" />
                <path d="M8.13,19.21h-.53c0,.51-.23,.98-.65,1.1v.48h.53v2.7c0,1.01,.04,1.6,.98,1.6h.37v-.48h-.32c-.5,0-.5-.41-.5-1.12v-2.7h.81v-.48h-1.24c.27-.09,.55-.55,.55-1.1Z" />
                <path d="M9.71,19.09c-.17,0-.32,.14-.32,.32s.15,.31,.32,.31c.18,0,.32-.14,.32-.31s-.14-.32-.32-.32Z" />
                <rect x="9.29" y="20.32" width=".53" height="4.77" />
                <path d="M11.52,20.24c-.86,0-1.17,.54-1.17,1.73v1.46c0,1.18,.31,1.73,1.17,1.73s1.18-.55,1.18-1.73v-1.46c0-1.18-.32-1.73-1.18-1.73Zm.64,3.36c0,.88-.25,1.09-.64,1.09s-.64-.21-.64-1.09v-1.79c0-.89,.25-1.09,.64-1.09s.64,.2,.64,1.09v1.79Z" />
                <path d="M14.64,20.24c-.52,0-.77,.35-.88,.61v-.54h-.53v4.77h.53v-3.45c0-.46,.2-.92,.69-.92,.44,0,.59,.35,.59,.87v3.5h.53v-3.38c0-1.04-.28-1.47-.94-1.47Z" />
                <rect x="15.59" y="9.84" width="3.84" height=".69" />
                <path d="M7.69,11.87c0,3.05-.47,6.41-3.9,6.41-2.57,0-3.79-1.74-3.79-5.66H1.69c0,2.5,.41,3.97,2.1,3.97,1.81,0,2.21-1.65,2.21-4.72s-.59-4.22-1.87-4.22c-1.4,0-2.12,1.35-2.28,2.59H.23L.68,0H6.97V1.69H2.21l-.27,5.62c.68-.79,1.49-1.35,2.62-1.35,2.03,0,3.14,1.83,3.14,5.91Z" />
                <path d="M15.51,16.36v1.69h-7.02v-1.69h2.66V2.37c-.5,.95-1.13,1.4-2.66,1.4v-1.62c1.38,0,2.23-.79,2.78-2.14h1.58V16.36h2.66Z" />
            </svg>
        </div>

        <div className={styles.bigEdition}>
            <svg
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                viewBox="0 0 389.4 451.4"
                className={styles.part}
            >
                <path
                    fill="#1e1e1e"
                    d="M389.4,80v-25.6c0-35.2-11-51-37.4-51s-38.3,15.8-38.3,51v44.7c0,35.2,11.8,51,38.3,51s37.4-15.8,37.4-51v-7h-21.9v10.3c0,22.5-5,28-15.5,28s-16.4-5.5-16.4-28v-22.3h53.8ZM335.6,51.2c0-22.5,5.9-28,16.4-28s15.5,5.5,15.5,28v13.6h-32v-13.6Z"
                />
                <rect fill="#1e1e1e" x="317.5" y="163.8" width="68.2" height="10.4" />
                <polygon
                    fill="#1e1e1e"
                    points="48.9 346.4 47.5 341.3 11.1 351.1 12.5 356.1 48.9 346.4"
                />
                <path
                    fill="#1e1e1e"
                    d="M30.3,362.7c-16,0-23.2,9.5-23.2,30.8v27c0,21.3,7.2,30.8,23.2,30.8s22.6-9.5,22.6-30.8v-4.2h-13.2v6.2c0,13.6-3.1,16.9-9.4,16.9s-9.9-3.3-9.9-16.9v-13.5h32.6v-15.5c0-21.3-6.6-30.8-22.6-30.8ZM39.7,399.8h-19.3v-8.2c0-13.6,3.6-16.9,9.9-16.9s9.4,3.3,9.4,16.9v8.2h0Z"
                />
                <path
                    fill="#1e1e1e"
                    d="M104.7,344.2h-13.2v29.5c-2.1-4.8-6.8-11-16.1-11s-16.4,8.2-16.4,26.9v34.9c0,18.7,4.2,26.9,16.4,26.9s14-6.2,16.1-11c0,2.4.7,7.7,2.6,9.7h11.9c-1.3-4.2-1.3-7.2-1.3-12.7v-93.2h0ZM91.5,425.8c0,7.7-3,13.6-10.3,13.6s-9-4.6-9-13v-38.9c0-8.3,2.4-13,9-13s10.3,6,10.3,13.6v37.6h0Z"
                />
                <rect fill="#1e1e1e" x="111.3" y="364" width="13.2" height="86" />
                <path
                    fill="#1e1e1e"
                    d="M117.9,342.9c-4,0-7.3,2.9-7.3,6.6s3.3,6.6,7.3,6.6,7.3-3.1,7.3-6.6-3.3-6.6-7.3-6.6Z"
                />
                <path
                    fill="#1e1e1e"
                    d="M155,344.2h-13.2c.1,8.9-3.4,17.6-11.2,19.9v11.9h9.3v45.3c0,19.3,1.9,28.8,19.6,28.8h8.2v-11.9h-5.8c-7.9,0-8.7-5.3-8.7-16.9v-45.3h14.6v-11.9h-22.5c5.7-1.7,9.9-10.2,9.9-19.9h0Z"
                />
                <rect fill="#1e1e1e" x="173.5" y="364" width="13.2" height="86" />
                <path
                    fill="#1e1e1e"
                    d="M180.1,342.9c-4,0-7.3,2.9-7.3,6.6s3.3,6.6,7.3,6.6,7.3-3.1,7.3-6.6-3.3-6.6-7.3-6.6Z"
                />
                <path
                    fill="#1e1e1e"
                    d="M215.6,362.7c-16,0-22.9,9.5-22.9,30.8v27c0,21.3,6.9,30.8,22.9,30.8s22.9-9.5,22.9-30.8v-27c0-21.3-6.9-30.8-22.9-30.8ZM225.2,422.5c0,13.6-3.3,16.9-9.7,16.9s-9.7-3.3-9.7-16.9v-31c0-13.6,3.3-16.9,9.7-16.9s9.7,3.3,9.7,16.9v31Z"
                />
                <path
                    fill="#1e1e1e"
                    d="M273.8,362.7c-9.4,0-14,6.2-16.1,11v-9.7h-13.2v86h13.2v-61.8c0-7.7,3-13.6,10.3-13.6s9,4.6,9,13v62.5h13.2v-60.5c0-18.7-4.2-26.9-16.4-26.9h0Z"
                />
                <g>
                    <path
                        fill="#1e1e1e"
                        d="M144,213.9c0,63.1-14.6,113.6-72,113.6S0,296.4,0,225.2h40.4c0,41.7,8.1,61.9,31.5,61.9s31.5-22.6,31.5-73.2-9.3-66.7-27.9-66.7-30.3,18.2-33.1,37.6H4.1L12.1,0h118.9v40.4H48.5l-4.9,86.9c11.7-12.1,25.9-20.6,43.7-20.6,36,0,56.6,31.9,56.6,107.1h0Z"
                    />
                    <path
                        fill="#1e1e1e"
                        d="M298,256h-28.3v67.5h-40.4v-67.5h-69.1v-40.4L229.3,0h40.4v215.5h28.3v40.4ZM229.3,215.5V82.9l-42.5,132.6h42.5Z"
                    />
                </g>
            </svg>
        </div>
    </div>
);

// 2022
// eslint-disable-next-line no-lone-blocks
{
    /* <svg
                className={styles.part}
                xmlns="http://www.w3.org/2000/svg"
                width="19.52"
                height="25.16"
                viewBox="0 0 19.52 25.16"
            >
                <path d="M19.52,4.68v-1.43c0-2.12-.55-3.1-2.08-3.1s-2.12,.98-2.12,3.1v2.62c0,2.12,.59,3.11,2.12,3.11s2.08-.99,2.08-3.11v-.38h-.95v.68c0,1.58-.42,1.95-1.13,1.95s-1.17-.37-1.17-1.95v-1.5h3.25Zm-3.25-1.72c0-1.6,.47-1.95,1.17-1.95s1.13,.36,1.13,1.95v.99h-2.3v-.99Z" />
                <path d="M1.49,20.24c-.86,0-1.18,.54-1.18,1.73v1.46c0,1.18,.33,1.73,1.18,1.73s1.16-.55,1.16-1.73v-.21h-.53v.38c0,.88-.23,1.09-.63,1.09s-.65-.21-.65-1.09v-.84h1.81v-.8c0-1.18-.31-1.73-1.16-1.73Zm.63,2.12H.83v-.55c0-.89,.26-1.09,.65-1.09s.63,.2,.63,1.09v.55Z" />
                <polygon points=".53 19.84 2.51 19.29 2.44 19 .46 19.55 .53 19.84" />
                <path d="M5.46,19.21h-.53v1.64c-.11-.27-.36-.61-.88-.61-.65,0-.93,.43-.93,1.47v1.97c0,1.04,.28,1.48,.93,1.48,.52,0,.77-.35,.88-.61,0,.13,.04,.43,.11,.54h.5c-.07-.24-.07-.4-.07-.7v-5.17Zm-.53,4.55c0,.46-.2,.93-.69,.93-.45,0-.59-.35-.59-.87v-2.23c0-.52,.14-.87,.59-.87,.5,0,.69,.46,.69,.92v2.12Z" />
                <rect x="6.05" y="20.32" width=".53" height="4.77" />
                <path d="M6.41,19.09c-.17,0-.32,.14-.32,.32s.15,.31,.32,.31c.18,0,.32-.14,.32-.31s-.14-.32-.32-.32Z" />
                <path d="M8.13,19.21h-.53c0,.51-.23,.98-.65,1.1v.48h.53v2.7c0,1.01,.04,1.6,.98,1.6h.37v-.48h-.32c-.5,0-.5-.41-.5-1.12v-2.7h.81v-.48h-1.24c.27-.09,.55-.55,.55-1.1Z" />
                <path d="M9.71,19.09c-.17,0-.32,.14-.32,.32s.15,.31,.32,.31c.18,0,.32-.14,.32-.31s-.14-.32-.32-.32Z" />
                <rect x="9.29" y="20.32" width=".53" height="4.77" />
                <path d="M11.52,20.24c-.86,0-1.17,.54-1.17,1.73v1.46c0,1.18,.31,1.73,1.17,1.73s1.18-.55,1.18-1.73v-1.46c0-1.18-.32-1.73-1.18-1.73Zm.64,3.36c0,.88-.25,1.09-.64,1.09s-.64-.21-.64-1.09v-1.79c0-.89,.25-1.09,.64-1.09s.64,.2,.64,1.09v1.79Z" />
                <path d="M14.64,20.24c-.52,0-.77,.35-.88,.61v-.54h-.53v4.77h.53v-3.45c0-.46,.2-.92,.69-.92,.44,0,.59,.35,.59,.87v3.5h.53v-3.38c0-1.04-.28-1.47-.94-1.47Z" />
                <rect x="15.59" y="9.84" width="3.84" height=".69" />
                <path d="M7.69,11.87c0,3.05-.47,6.41-3.9,6.41-2.57,0-3.79-1.74-3.79-5.66H1.69c0,2.5,.41,3.97,2.1,3.97,1.81,0,2.21-1.65,2.21-4.72s-.59-4.22-1.87-4.22c-1.4,0-2.12,1.35-2.28,2.59H.23L.68,0H6.97V1.69H2.21l-.27,5.62c.68-.79,1.49-1.35,2.62-1.35,2.03,0,3.14,1.83,3.14,5.91Z" />
                <path d="M15.51,16.36v1.69h-7.02v-1.69h2.66V2.37c-.5,.95-1.13,1.4-2.66,1.4v-1.62c1.38,0,2.23-.79,2.78-2.14h1.58V16.36h2.66Z" />
            </svg> */
}

FncLogo.propTypes = propTypes;
FncLogo.defaultProps = defaultProps;

export default FncLogo;
